/** @type {import('../help-index.js').HelpScreen} */
export const SETTINGS_PAY_CARDS_HELP = {
  screenId: 'settings-pay-cards',
  label: 'Agregar tarjeta',
  navPath: 'Configuración → Agregar tarjeta',
  keywords: ['tarjeta', 'suscripción', 'visa', 'mastercard', 'débito automático', 'débito', 'crédito'].map((k) => k.toLowerCase()),
  status: 'draft',
  summary: 'Tarjetas VISA (crédito o débito) o Mastercard de crédito para el cobro automático de la suscripción del sistema.',
  sidebarItems: [{
    id: 'pay-cards',
    screenId: 'settings-pay-cards',
    label: 'Tarjetas de suscripción',
    description: 'Alta, baja y tarjeta predeterminada.',
    detail: {
      sections: [
        {
          title: 'Para qué sirve',
          intro: 'Registrás la tarjeta con la que se debita la suscripción de pymego. Se aceptan VISA crédito, VISA débito y Mastercard crédito. Mastercard débito no está habilitada.',
        },
        {
          title: 'Qué datos se piden',
          paragraphs: [
            'El número de tarjeta y si es de crédito o de débito. No se solicita vencimiento ni código de seguridad.',
            'El número alcanza para reconocer VISA o Mastercard. Crédito o débito lo elegís vos: una VISA débito y una de crédito pueden empezar igual.',
          ],
        },
        {
          title: 'Paso 1 — Agregar tarjeta',
          steps: [
            'Entrá a Configuración → Agregar tarjeta.',
            'Ingresá el número en el campo «Número de tarjeta».',
            'En «Tipo» elegí Crédito o Débito. Mastercard solo admite crédito.',
            'Tocá «Agregar tarjeta» cuando el número sea válido.',
          ],
        },
        {
          title: 'Paso 2 — Tarjetas registradas',
          bullets: [
            'La lista muestra marca y número enmascarado.',
            'Si hay más de una, elegí «Predeterminada» en la que se usará para el débito.',
            'Ícono de papelera — elimina la tarjeta de la lista.',
          ],
        },
      ],
    },
  }],
}
